import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import NewDeliveryDialog from "./NewDeliveryDialog";
import { useState } from "react";
import { Button } from "primereact/button";

const DeliveriesTable = ({
  dailyReport,
  setDailyReport,
  updateDailyReportMutation,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const hideDialog = () => {
    setIsVisible(false);
  };

  const header = () => {
    return (
      <div className="flex align-items-center justify-content-between gap-2">
        <span className="text-xl text-900 font-bold">Deliveries</span>
        <Button
          className="w-9rem"
          label="Create"
          icon="pi pi-plus"
          onClick={() => {
            setIsVisible(true);
          }}
        />
      </div>
    );
  };

  const cellEditor = (options) => {
    return textEditor(options);
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const onCellEditComplete = (e) => {
    let { newValue, field, rowIndex } = e;

    let shouldUpdated = dailyReport["deliveries"][rowIndex][field] !== newValue;

    if (!shouldUpdated) {
      return;
    }

    let _dailyReport = { ...dailyReport };
    _dailyReport["deliveries"][rowIndex][field] = newValue;
    setDailyReport(_dailyReport);

    let updatedData = { deliveries: _dailyReport["deliveries"] };
    updateDailyReportMutation({
      dailyReport: updatedData,
      dailyReportId: dailyReport._id,
    });
  };

  const handleRemoveRow = (rowIndex) => {
    let _dailyReport = { ...dailyReport };
    _dailyReport.deliveries.splice(rowIndex, 1);
    setDailyReport(_dailyReport);

    let updatedData = { deliveries: _dailyReport["deliveries"] };
    updateDailyReportMutation({
      dailyReport: updatedData,
      dailyReportId: dailyReport._id,
    });
  };

  const actionBodyTemplate = (rowData, options) => {
    const { rowIndex } = options;
    return (
      <Button
        type="button"
        icon="pi pi-times"
        rounded
        severity="danger"
        onClick={() => handleRemoveRow(rowIndex)}
        text
      />
    );
  };

  return (
    <>
      <div className="card p-fluid">
        <DataTable
          value={dailyReport.deliveries}
          editMode="cell"
          header={header}
        >
          <Column
            key="delivery_vendor_name"
            field="delivery_vendor_name"
            header="Vendor"
            style={{ width: "50%" }}
            editor={(options) => cellEditor(options)}
            onCellEditComplete={onCellEditComplete}
          />
          <Column
            key="delivery_vendor_note"
            field="delivery_vendor_note"
            header="Note"
            style={{ width: "50%" }}
            editor={(options) => cellEditor(options)}
            onCellEditComplete={onCellEditComplete}
          />
          <Column
            headerStyle={{ width: "5rem", textAlign: "center" }}
            bodyStyle={{ textAlign: "center", overflow: "visible" }}
            body={actionBodyTemplate}
          />
        </DataTable>
      </div>
      <NewDeliveryDialog
        isVisible={isVisible}
        hideDialog={hideDialog}
        dailyReport={dailyReport}
        setDailyReport={setDailyReport}
      />
    </>
  );
};
export default DeliveriesTable;
